import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// Wait for Drupal to be ready
document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('react-map-root');
  
  if (container) {
    try {
      const root = createRoot(container);
      root.render(
        <StrictMode>
          <App />
        </StrictMode>
      );
    } catch (error) {
      console.error('Error mounting React app:', error);
    }
  } else {
    console.error('Could not find react-map-root element');
  }
});
